import { Text, } from "@bracket/ui/components";
import type { ReactNode, } from "react";


export declare type TabularRasaEmptyAccessorProps = {
	accessorData?: Record<string, any>;
};

export const TabularRasaEmptyAccessor = ({ accessorData = {}, }: TabularRasaEmptyAccessorProps): ReactNode => {
	return <Text>&nbsp;</Text>;
};

